(function ($, Drupal, drupalSettings, once) {
  Drupal.behaviors.moreLink = {
    attach: function (context, settings) {
      once("moreLink", ".home-slider .more, .produit-banner .more", context).forEach(function (element) {
        $(element).click(function () {
          var linkTo = $(this).parent().next("section");
          $([document.documentElement, document.body]).animate(
            {
              scrollTop: linkTo.offset().top,
            },
            2000,
          );
        });
      });
    },
  };
})(jQuery, Drupal, drupalSettings, once);
